export default __webpack_public_path__ + "static/media/MAIDEN.61916809.jpg";